import { Link, LinkProps } from 'react-router-dom'

import { config } from '@/config'
import { RoutePaths } from '@/routes'
import { cn } from '@/theme/utils'

export default function Logo(props: Omit<LinkProps, 'to'>) {
  // const { theme, systemTheme } = useTheme()

  // const currentTheme = theme === 'system' ? systemTheme : theme

  return (
    <Link
      {...props}
      to={RoutePaths.Root}
      className={cn('w-full max-w-[184px]', props.className)}
    >
      <img
        src='/branding/logo-large-dark.svg'
        alt={config.VITE_APP_NAME}
        className='h-auto w-full object-contain'
      />
    </Link>
  )
}
